import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
export var PropertiesHeader = function (props) {
    var _a;
    return (_jsxs(_Fragment, { children: [props.seeToast.show &&
                props.showToast(position.topRight, props.seeToast.type, props.seeToast.message, function () {
                    props.setSeeToast({
                        show: false,
                        message: "",
                        type: typeAlert.success,
                    });
                }), _jsx(LoadingAFY, { loading: props.loading, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: (_a = props.textLoading) !== null && _a !== void 0 ? _a : "Cargando...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third })] }));
};
